
const initialState = {
	addresses: false,
}

export const AddressReducer = (state = initialState, action = {}) => {
   switch (action.type) {
         //case 'persist/REHYDRATE':
         //   return action.payload ? action.payload.AddressReducer ? action.payload.AddressReducer : state : state;
        case 'USER_ADDRESSES_FETCHED':
        	return {
                ...state,
                addresses: action.payload              
            }
        case 'SET_ADDRESS_IMAGE':
            let addresses = state.addresses;
            let addressIndex = addresses.findIndex( address => address.dp_address_id === action.payload.dp_address_id );
            addresses[addressIndex]['address_image'] = action.payload.photo;

            return {
                ...state,
                addresses: addresses
            }
        case 'SET_ADDRESS_IMAGE_REFRESHING':
            let allAddresses = state.addresses; 
            let currentIndex = allAddresses.findIndex( address => address.dp_address_id === action.payload.dp_address_id );
            allAddresses[currentIndex]['address_image_refreshing'] = action.payload.status;

            return {
                ...state,
                addresses: allAddresses
            }

        case 'DESTROY':
        case 'DESTROY_ADDRESSES':
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/AddressReducer.js